
import React, { useEffect, useCallback, useState } from "react";
import { Modal, Input, notification } from "antd";
import UserApi from "../common/Apis/UserApi";
import { useNavigate } from "react-router-dom";

const AptitudeTest = (props) => {
  let navigate = useNavigate();
  const urlParams = new URLSearchParams(window.location.search);
  let token = urlParams.get("token");
  const userStatus = urlParams.get("status");
  const tenantID = urlParams.get("tenantId");
  const subTenantId = urlParams.get("subTenantId");

  const [email, setEmail] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false); // To ensure we initialize correctly

  const tokenVerification = useCallback(
    (userEmail) => {
      UserApi.tokenVerification(token)
        .then((response) => {
          console.log(userStatus);
          if (userStatus === "MCQ_TEST") {
            return navigate("/induction");
          } else if (userStatus === "PROTECTIVE_CLOTHING") {
            return navigate("/protective");
          } else if (userStatus === "HEALTH_QUESTIONNAIRE") {
            return navigate("/questionnaire");
          } else if (userStatus === "PENDING") {
            return navigate("/induction");
          } else if (userStatus === "INDUCTION_VIDEO") {
            return navigate("/induction");
          } else {
            return navigate("/");
          }
        })
        .catch((err) => {
          if (err.success === false) {
            return navigate("/");
          }
        });
    },
    [token, navigate, userStatus]
  );

  useEffect(() => {
    localStorage.setItem("testPriority", 1);

    if (tenantID) {
      const userEmail = urlParams.get("email");
      localStorage.setItem("tenantID", tenantID);
      if (userEmail) {
        localStorage.setItem("userEmail", userEmail);
      }

      if (subTenantId) {
        localStorage.setItem("subTenantId", subTenantId);
      }
    } else {
      localStorage.setItem("tenantID", null);
    }

    if (token) {
      localStorage.setItem("userToken", token);
    } else {
      token = localStorage.getItem("userToken");
    }

    const storedEmail = localStorage.getItem("userEmail");
    if (!storedEmail) {
      setIsModalOpen(true);
    } else {
      setEmail(storedEmail);
      tokenVerification(storedEmail);
    }

    setIsInitialized(true); // Initialization is complete
  }, [tenantID, subTenantId, token, tokenVerification]);

  const handleOk = () => {
    if (email) {
      localStorage.setItem("userEmail", email);
      setIsModalOpen(false);
      tokenVerification(email);
    } else {
      notification.error({ message: "Please enter your email." });
    }
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    navigate("/");
  };

  if (!isInitialized) {
    return null; // Render nothing until initialization is complete
  }

  return (
    <Modal
   
      title="Enter your email"
      open={isModalOpen}
      onOk={handleOk}
      onCancel={handleCancel}
    >
     <p>For verification purposes, we need your email.</p>
      <Input
        placeholder="Enter your email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
    </Modal>
  );
};

export default AptitudeTest;
